import BoolBox from './src/BoolBox'

BoolBox.install = function (Vue) {
    Vue.component(BoolBox.name, BoolBox);
};

export default BoolBox;